import { invokeProtectedFunction } from "@/lib/invokeProtectedFunction";
import { SHOPIFY_CUSTOMER_PORTAL } from "@/components/landing/homepage-data";

/**
 * Opens the Seal customer portal for the signed-in subscriber, preferring the
 * per-customer magic link (lands directly on THEIR subscriptions, no login
 * dance) over the static hosted portal page.
 *
 * Must be called synchronously from a click handler: it opens the tab first
 * (popup blockers allow that inside a user gesture) and navigates it once the
 * magic link resolves — falling back to the static portal URL on any failure.
 */
export function openCustomerPortal(): void {
  // No "noopener" here — that makes window.open return null and we need the
  // handle to navigate the tab once the magic link resolves. Both destinations
  // are our own billing portals, so reverse-tabnabbing isn't a concern.
  const tab = window.open("about:blank", "_blank");

  void (async () => {
    let url = SHOPIFY_CUSTOMER_PORTAL;
    try {
      const { data } = await invokeProtectedFunction<{ ok?: boolean; url?: string | null }>(
        "get-subscription-portal-link",
        { body: {} },
      );
      if (data?.url) url = data.url;
    } catch {
      // fall through to the static portal
    }
    if (tab) {
      tab.location.href = url;
    } else {
      // Popup was blocked despite the gesture — navigate in place as a fallback.
      window.location.href = url;
    }
  })();
}
